const MODEL_DISPLAY_NAMES: Record<string, string> = {
  'gpt-5.5': 'GPT-5.5',
  'claude-sonnet-4-6': 'Claude Sonnet 4.6',
}

const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  openai: 'OpenAI',
  claude: 'Claude',
}

export function formatLlmModelDisplay(
  llmModelName?: string | null,
  llmProvider?: string | null,
  legacyProvider?: string | null
): string | null {
  if (llmModelName) {
    return MODEL_DISPLAY_NAMES[llmModelName] ?? llmModelName
  }
  const provider = llmProvider ?? legacyProvider
  if (provider) {
    return PROVIDER_DISPLAY_NAMES[provider] ?? provider
  }
  return null
}
